<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-12">
            <yt-dropdown-picklist
                [ModelName]="'zaposleni'"
                [GetName]="'get'"
                [ModelProperty]="'Prezime,Ime,Jmbg'"
                [OrderBy]="'Prezime'"
                [AllowAddNew]="false"
                formControlName="OsobaID"
                [Label]="'OSOBARADNAOPREMA.OSOBA.SINGULAR'">
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.VelicinaStavID.invalid">
                <span *ngFor="let validation of errorMessages.VelicinaStavID">
                    <span class="error-message" *ngIf="fc.VelicinaStavID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">
            <yt-dropdown-picklist
                [ModelName]="'tipradneopreme'"
                [GetName]="'get'"
                [ModelProperty]="'Naziv'"
                formControlName="TipRadneOpremeID"
                [Label]="'OSOBARADNAOPREMA.TIPRADNEOPREME.SINGULAR'"
                [ngClass]="{'is-invalid': submitted && fc.TipRadneOpremeID.invalid}"
                [AllowAddNew]="false"
                (OnItemSelected)="onItemSelected($event)">
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.TipRadneOpremeID.invalid">
                <span *ngFor="let validation of errorMessages.TipRadneOpremeID">
                    <span class="error-message" *ngIf="fc.TipRadneOpremeID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <div class="col-md-12">

            <!-- [GetParameters]="'VelicinaSetID'" -->


            <yt-dropdown-picklist
                [ModelName]="'velicinastav'"
                [GetName]="'getbyvelicinasetid'"
                [GetParameters]='parameterList'   
                [ModelProperty]="'Naziv'"
                [OrderBy]="'Naziv'"
                [AllowAddNew]="false"
                formControlName="VelicinaStavID"
                [Label]="'OSOBARADNAOPREMA.VELICINASTAV.SINGULAR'"
            >
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.VelicinaStavID.invalid">
                <span *ngFor="let validation of errorMessages.VelicinaStavID">
                    <span class="error-message" *ngIf="fc.VelicinaStavID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                </span>
            </div>
        </div>
    </div>

</form>